'use strict';

import { Vector2 } from 'three';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass';
import { assignDeep } from '../../../settings';
import { Effect } from './Effect';

const DEFAULT_PARAMS = {
  strength: 1.5,
  radius: 0.4,
  threshold: 0.85
};

export class Bloom extends Effect {
  constructor (renderer,params = {}) {
    super();
    const settings = assignDeep(DEFAULT_PARAMS,params);
    this.effect = new UnrealBloomPass(renderer.getSize( new Vector2()),settings.strength,settings.radius,settings.threshold);
  }

  set config(conf) {
    this.effect.strength = conf.strength;
    this.effect.radius = conf.radius;
    this.effect.threshold = conf.threshold;
    this.active = conf.hasOwnProperty('enabled') ? conf.enabled : conf.active;
  }
  
  get config() {
    return {
      strength: this.effect.strength,
      radius: this.effect.radius,
      threshold: this.effect.threshold,
      enabled: this.active
    }
  }

}
